import { useTranslation } from 'react-i18next';

import { formatCurrency } from 'support/helpers/currency/currency';

type TotalProps = {
  amount: number;
  currency: string | undefined;
};

export function Total({ amount, currency }: TotalProps) {
  const { t } = useTranslation();

  return (
    <dl className="flex items-center justify-between pt-6">
      <dt className="text-xs font-normal leading-4 text-gray-500">{t('orderForms:checkout.totalAmount')}</dt>
      <dd className="text-base font-bold leading-6 text-gray-900">{formatCurrency(amount, currency)}</dd>
    </dl>
  );
}
